import React, { useMemo, useCallback } from 'react'
import styled from 'styled-components'
const CenteredHead = styled.div`
    flex: none;
    width: 100%;
    text-align: center;
`

const EmptyTitleHeader = ({
    // rowSelector='id', //unique key for the row
    fields,
    tableTile,
    noDataMessage='No data to display',
}) => {
    const noData = useMemo(() => !fields || (fields && fields.length <= 0), [fields])
    return (
        <CenteredHead>
            <h3>{tableTile}</h3>
            <span>{noDataMessage}</span>
        </CenteredHead>
    )
}

export default EmptyTitleHeader